import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import connectionErrorSvg from 'assets/connection-error.svg';
import { ErrorPage } from 'components/error-page/error-page.component';

interface ConnectionErrorPageProps {
  retry?: () => void;
}

export const ConnectionErrorPage = ({
  retry,
}: ConnectionErrorPageProps = {}) => {
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_ERROR_STATE_HEADING_GENERIC' }));

  return (
    <ErrorPage
      imageSrc={connectionErrorSvg}
      headingString={formatMessage({ id: 'STR_ERROR_STATE_HEADING_GENERIC' })}
      bodyString={formatMessage({ id: 'STR_ERROR_STATE_BODY_API' })}
      buttonText={formatMessage({ id: 'STR_RELOAD' })}
      onButtonClick={retry}
    />
  );
};
